import Http from '@/Http';

export default class PubHttp extends Http {
  constructor (addUrl?:string) {
    super(addUrl);
    this.addUrl = 'public/';
  }
}
